import React, { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import {
  useEditDataSourceMutation,
  useGetSingleDSMutation,
} from "./EditDataSourceSlice";
import { AiOutlineSave } from "react-icons/ai";
import { useState } from "react";
import { FaEyeSlash, FaRegEye } from "react-icons/fa6";
import LoadingIndicator from "../../components/BasicComponents/LoadingIndicator";

export default function EditDSPage() {
  const [searchParams] = useSearchParams();
  const dataSourceId = searchParams.get("dataSourceId");
  // console.log(dataSourceId);
  const navigate = useNavigate();
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [confirmPasswordVisible, setConfirmPasswordVisible] = useState(false);
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [checkDSFields, setCheckDSFields] = useState("");
  // console.log(checkDSFields);

  const [
    editDataSource,
    {
      data: editDataSourceMessage,
      isLoading: isEditDataSourceLoading,
      isSuccess: isEditDataSourceSuccess,
      isError: isEditDataSourceError,
      error: editDataSourceError,
    },
  ] = useEditDataSourceMutation();
  const [
    getSingleDS,
    {
      data: dataSourceDetails,
      isLoading: isDataSourceDetailsLoading,
      isSuccess: isDataSourceDetailsSuccess,
      isError: isDataSourceDetailsError,
      error: dataSourceDetailsError,
    },
  ] = useGetSingleDSMutation();
  const [dsDetails, setDsDetails] = useState(null);

  useEffect(() => {
    if (dataSourceId) {
      getSingleDS(dataSourceId);
    }
  }, [dataSourceId]);

  useEffect(() => {
    if (dataSourceDetails) {
      setDsDetails(dataSourceDetails);
    }
  }, [isDataSourceDetailsSuccess, dataSourceDetails]);

  useEffect(() => {
    if (dsDetails !== null) {
      const hasEmptyFields = Object.values(dsDetails).some(
        (value) => value === ""
      );
      if (hasEmptyFields) {
        setCheckDSFields("Fields cannot be empty");
      } else {
        setCheckDSFields("");
      }
      if (password !== confirmPassword) {
        setCheckDSFields("both password fields should be same");
      } else {
        setCheckDSFields("");
      }
    }
  }, [dsDetails, password, confirmPassword]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setDsDetails((prev) => ({ ...prev, [name]: value }));
    if (name === "password") {
      setPassword(value);
    }
    if (name === "confirmPassword") {
      setConfirmPassword(value);
    }
  };

  const handleSave = () => {
    console.log(dsDetails);
    const editedUserDetails = {
      connectionId: dsDetails.id,
      newDetails: {
        id: dsDetails.id,
        Host: dsDetails.Host,
        Owner: dsDetails.Owner,
        NickName: dsDetails.NickName,
        DataBaseName: dsDetails.DataBaseName,
        AddedOn: dsDetails.AddedOn,
        port: dsDetails.port,
        type: dsDetails.DatabaseType,
        password: dsDetails.password !== undefined ? dsDetails.password : " ",
      },
    };
    console.log(editedUserDetails);
    editDataSource(editedUserDetails);
  };
  useEffect(() => {
    if (editDataSourceMessage && editDataSourceMessage[`success`]) {
      const timer = setTimeout(() => {
        navigate("/home/dash/editdatasource");
      }, 1000);
      return () => clearTimeout(timer);
    }
  }, [editDataSourceMessage]);

  if (isDataSourceDetailsLoading) {
    <LoadingIndicator />;
  }
  if (isDataSourceDetailsError) {
    console.log(dataSourceDetailsError);
    <main className="overflow-hidden flex flex-col w-full h-[92vh] font-medium">
      {dataSourceDetailsError}
    </main>;
  }

  if (dsDetails !== null) {
    console.log(dsDetails);

    return (
      <main className="overflow-hidden flex flex-col w-full h-[92vh]">
        <section className="flex items-center justify-between px-[0.8rem] border border-b-0 border-gray-300 h-[6%] font-medium w-full gap-2">
          <div className="flex items-center justify-start w-[70%] gap-2">
            {dsDetails.NickName}
            {isEditDataSourceError ? (
              <p className="text-red-500 font-medium">
                {editDataSourceError["data"]["error"]}
              </p>
            ) : null}
            {isEditDataSourceSuccess ? (
              <p className="text-green-500 font-medium">
                {editDataSourceMessage[`success`]}
              </p>
            ) : null}
          </div>
        </section>
        <section className="flex flex-wrap items-start justify-start p-[0.8rem] border border-b-0 border-gray-300 h-[65%] w-full">
          <div className="flex flex-col w-[33%] items-start justify-start gap-2">
            <label htmlFor="NickName" className="font-medium">
              Data Source Name
            </label>
            <input
              type="text"
              name="NickName"
              value={dsDetails.NickName}
              onChange={handleInputChange}
              className="border rounded w-[88%] h-[4%] p-[0.2rem] focus:outline-0"
            />
          </div>
          <div className="flex flex-col w-[33%] items-start justify-start gap-2">
            <label htmlFor="DataBaseName" className="font-medium">
              Database Name
            </label>
            <input
              type="text"
              name="DataBaseName"
              value={dsDetails.DataBaseName}
              onChange={handleInputChange}
              className="border rounded w-[88%] h-[4%] p-[0.2rem] focus:outline-0"
            />
          </div>
          <div className="flex flex-col w-[33%] items-start justify-start gap-2">
            <label htmlFor="port" className="font-medium">
              Port
            </label>
            <input
              name="port"
              value={dsDetails.port}
              onChange={handleInputChange}
              className="border rounded w-[88%] h-[4%] p-[0.2rem] focus:outline-0"
            />
          </div>
          <div className="flex flex-col w-[33%] items-start justify-start gap-2">
            <label htmlFor="Host" className="font-medium">
              Host
            </label>
            <input
              name="Host"
              value={dsDetails.Host}
              onChange={handleInputChange}
              className="border rounded w-[88%] h-[4%] p-[0.2rem] focus:outline-0"
            />
          </div>
          <div className="flex flex-col w-[33%] items-start justify-start gap-2">
            <label htmlFor="Owner" className="font-medium">
              Owner
            </label>
            <input
              type="text"
              name="Owner"
              value={dsDetails.Owner}
              className="border rounded w-[88%] h-[4%] p-[0.2rem] focus:outline-0"
            />
          </div>
          <div className="flex flex-col w-[33%] items-start justify-start gap-2">
            <label htmlFor="DatabaseType" className="font-medium">
              DatabaseType
            </label>
            <input
              type="text"
              name="DatabaseType"
              value={dsDetails.DatabaseType}
              onChange={handleInputChange}
              className="border rounded w-[88%] h-[4%] p-[0.2rem] focus:outline-0"
            />
          </div>
          <div className="flex flex-col w-[33%] items-start justify-start gap-2">
            <label htmlFor="AddedOn" className="font-medium">
              AddedOn
            </label>
            <input
              type="text"
              name="AddedOn"
              value={dsDetails.AddedOn}
              className="border rounded w-[88%] h-[4%] p-[0.2rem] focus:outline-0"
            />
          </div>
          <div className="flex flex-col w-[33%] items-start justify-start gap-2">
            <label htmlFor="AddedBy" className="font-medium">
              AddedBy
            </label>
            <input
              type="text"
              name="AddedBy"
              value={dsDetails.AddedBy}
              className="border rounded w-[88%] h-[4%] p-[0.2rem] focus:outline-0"
            />
          </div>
          <div className="flex flex-col w-[33%] items-start justify-start gap-2">
            <label htmlFor="password" className="font-medium">
              Password
            </label>
            <div className="relative w-full">
              <input
                type={passwordVisible ? "text" : "password"}
                name="password"
                placeholder="enter the new password"
                onChange={handleInputChange}
                value={password}
                className="border rounded w-[88%] p-[0.2rem] focus:outline-0"
              />
              <button
                type="button"
                className="absolute right-[13.5%] top-[20.8%] focus:outline-0"
                onClick={() => setPasswordVisible(!passwordVisible)}
              >
                {passwordVisible ? <FaRegEye /> : <FaEyeSlash />}
              </button>
            </div>
          </div>
          <div className="flex flex-col w-[33%] items-start justify-start gap-2">
            <label htmlFor="confirmPassword" className="font-medium">
              Confirm Password
            </label>
            <div className="relative w-full">
              <input
                type={confirmPasswordVisible ? "text" : "password"}
                name="confirmPassword"
                placeholder="confirm the new password"
                onChange={handleInputChange}
                className="border rounded w-[88%] p-[0.2rem] focus:outline-0"
              />
              <button
                type="button"
                className="absolute right-[13.5%] top-[20.8%] focus:outline-0"
                value={confirmPassword}
                onClick={() =>
                  setConfirmPasswordVisible(!confirmPasswordVisible)
                }
              >
                {confirmPasswordVisible ? <FaRegEye /> : <FaEyeSlash />}
              </button>
            </div>
          </div>
        </section>
        <section className="flex items-center justify-end w-full h-[10%] px-[5rem] py-[0.8rem] gap-4">
          {checkDSFields !== "" ? (
            <p className="text-red-500 font-medium">{checkDSFields}</p>
          ) : null}
          <button
            className="border rounded py-2 px-3 text-gray-700 hover:bg-gray-200"
            onClick={() => navigate("/home/dash/editdatasource")}
          >
            Cancel
          </button>
          {/*  */}
          <button
            className={`border rounded py-2 px-6  flex items-center justify-center gap-1 text-white 
              ${checkDSFields !== "" ? " bg-gray-500" : "bg-blue-950"}  `}
            disabled={checkDSFields !== ""}
            onClick={handleSave}
          >
            {isEditDataSourceLoading ? "Saving..." : "Save"}
            <AiOutlineSave />
          </button>
        </section>
      </main>
    );
  }
}
